/**
 * Regpath Landing
 * Functionaity for main landing page of regpath
 * 
 * Config Options
 * -- landingPage : Landing Page that the user is sent to if no is selected for all offers, or if you’ve run out of offers
 * -- track1 : Sets the track1 value in the session storage
 */
define('components/regpath-landing',[
    "jquery",
    "utilities",
    "logging",
    "storage",
    "components/offers"
], function($, utilities, logging, storage, offers) {
    "use strict";

    var _ModuleName = "RegPath Landing Page";
    var _submitLock = false;

    var _config = {
        tracking: {
            name: "track01"
        }
    };
    var _data = {
        paths: [],
        landingPage: ""
    };

    var init = function(data) {
        if(data && data.landingPage) {
            _data.landingPage = data.landingPage;
        }

        if(data && data.track1) {
            utilities.setTrackingValue(_config.tracking.name, data.track1);
        }
    }

    var run = function() {
        logging.debug("Creating regpath", _ModuleName);
        
        // Get handle on form
        var $form = $('form');

        // Make sure we got the form
        if ($form.length) {
            // Make sure we're only working with the first form
            if ($form.length > 1) {
                $form = $($form[0]);
            }
            
            logging.debug("Disabling Default Form Submit", _ModuleName);
            // remove the default form actions, and set up our own.
            $form.unbind();
            $form.removeAttr('action').removeAttr('method');
            $form.submit(function (event) {
                event.preventDefault();
                return false;
            });
        
            // Get handle on submit button
            var $submit = $('.lp-pom-button');
            if ($submit.length < 1) {
                logging.error('failed to find the submit button', _ModuleName);
                return;
            }
        
            // Disconnect other actions from the submit button
            $submit.unbind();
            if (window.lp && window.lp.jQuery) {
                window.lp.jQuery($submit).unbind();
            }
            
            // Update path values with tracking parameter
            var tracking = utilities.getTrackingValue(_config.tracking.name);
            if(tracking) {
                $('input[type=checkbox]', $form).each(function(i, elem){
                    var $checkbox = $(elem);
                    var path = $checkbox.attr('value');
                    if(path) {
                        $checkbox.attr('value', path + (path.indexOf('?') < 0 ? '?' : '&') + _config.tracking.name + '=' + tracking);
                    }
                });
                // Save tracking parameter to local storage (in case it wasn't already there)
                utilities.setTrackingValue(_config.tracking.name, tracking);
            }

            // Configure form submission
            $submit.click(function (e) {
                /* make sure we don't let the event bubble up and post the form */
                if (e.preventDefault) { e.preventDefault(); }
                if (e.stopPropagation) { e.stopPropagation(); }
        
                // Check if lock exists
                if (_submitLock) {
                    logging.warn("Button has already been clicked, please sit tight", _ModuleName);
                    return;
                }
        
                // Enable Lock
                _submitLock = true;
        
                // Get configured landing page, but fallback if not defined
                if(!_data.landingPage) {
                    var $landingPage = $('[name=LandingPage]', $form);
                    _data.landingPage = ($landingPage.length > 0) 
                        ? $landingPage.attr('value') 
                        : 'https://l.beliefnet.com/beliefnet-devotional-bibleoffer/?'+ window.location.search.substring(1);
                }
        
                // Get Paths
                var $inputs = $('input[type=radio]', $form);
                var $inputSelections = $('input[type=radio]:checked', $form);
                if($inputSelections.length < $inputs.length / 2) {
                    alert('Please select yes or no for all offers to continue');
                    _submitLock = false;
                    return false;
                }
    
                // now scrape the URL values from any of the checked yes radios
                $inputSelections.filter(function () {
                    return $(this).attr('value') && $(this).attr('value').length > 2;
                }).each(function (idx, el) {
                    var url = $(el).attr('value') || '';
                    if (url.length) _data.paths.push(url);
                });
    
                if (_data.paths.length == 0) {
                    // selecting no for all offers is now ok. just forward them to the 
                    // landing page if that is the case.
                    window.location.href = _data.landingPage;
                    return false;
                }
        
                if(offers.create(_data.paths, _data.landingPage)) {
                    var nextOffer = offers.next();
                    if(nextOffer) {
                        window.location.href = nextOffer;
                    } else {
                        alert('Something went wrong. Please try your submission again in a few minutes');
                        logging.error("Something was wrong with the offer URL we got back", _ModuleName);
                        _submitLock = false;
                    }
                } else {
                    alert('Something went wrong. Please try your submission again in a few minutes');
                    logging.error("Something went wrong creating the offer path", _ModuleName);
                    _submitLock = false;
                }

                return false;
            });
        
            // Show Button if it is hidden
            var styles = $submit.attr('style');
            $submit.attr('style', styles + ';display:inline-block !important;');
        } else {
            logging.error('unable to find the form to create the regpath for', _ModuleName);
            return false;
        }
    }

    return {
        init: init,
        run: run
    }
});
